const loadLazyImages = () => {
	const images = Array.prototype.slice.call(document.querySelectorAll('img[data-src]'), 0);
	images.forEach((image) => {
		let src = image.getAttribute('data-src');
		const srcMobile = image.getAttribute('data-src-mobile');
		if (srcMobile && window.innerWidth < 768) {
			src = srcMobile;
		}
		image.removeAttribute('data-src');
		image.removeAttribute('data-src-mobile');
		image.setAttribute('src', src);
	});
}

export default loadLazyImages;
